$(function () {
    $('[data-scroll-start]').click(function (event) {
        event.preventDefault();
        var targetSelector = this.hash.slice(1);
        var target = $("[data-scroll-target='" + targetSelector + "']");

        if (target.length) {
            smoothScrollingTo(target);
        }
    });

    $('[data-scrollto="next-row"]').click(function (event) {
        event.preventDefault();
        var target = $(this).closest('.row').next('.row');
       
        if (target.length) {
            smoothScrollingTo(target);
        }
    });

    $(document).on('click', 'a[href*=\\#]', function (event) {
        // event.preventDefault();
        if (this.hash.length) {
            smoothScrollingTo(this.hash);
        }
    });
});

$(document).ready(function () {
    var initScrollTriggers = $('.initscroll, .bbp-template-notice.error, .validation_error, .af-success');
    if (initScrollTriggers.length) {
        smoothScrollingTo(initScrollTriggers);
    } else if (location.hash) {
        smoothScrollingTo(location.hash);
    }
});

function smoothScrollingTo(target) {
    $('html, body').animate({
        scrollTop: $(target).offset().top
    }, 500);
}
